import { Col, Row,Image } from 'antd';
import React, {useEffect, useRef, useState} from 'react';
import './index.css'
import { useSelector } from 'react-redux';
import {getHistoryMessages, hyperChat} from "../../../api/other";
import Question from "./chatQuestion";
import Answer2 from "./chatAnswer/sse";
import Answer from "./chatAnswer";


const ChatApp = (props) => {
    const {sendTxt, setSendTxt,clearContent,setClearContent,themeVlue} = props
    const {size} = useSelector(state=>state.fontSizeChange)
    const [pageList, setPageList] = useState([])
    const {userInfo, allContextMeta,leftIndex} = useSelector(state => state.user)
    var chat_meta = null;
    if(userInfo&&allContextMeta){
        chat_meta = allContextMeta.chat_meta[parseInt(leftIndex)]
    }
    const sizeStyle = {
        fontSize:size==='小'?'15px':(size==='中'?'18px':'22px')
    }
    const answerTwo = {
        fontSize:size==='小'?'18px':(size==='中'?'21px':'25px')
    }
	const [viewType,setViewType] = useState('instant')
    useEffect(() => {
        if (sendTxt) {
            let list2 = {
                user_content:sendTxt.user_content,
                responder_content:[{state:true}]
            }
            pageList.push(list2)
			setViewType('smooth')
            setPageList([...pageList])
        }
    }, [sendTxt])
    useEffect(()=>{
        handleScrollContainer()
    },[pageList])
    useEffect(() => {
		if (clearContent) {
			getHisList()
		}
	}, [clearContent])
	var isGetHisList = false
	useEffect(()=>{
		if(!isGetHisList){
			isGetHisList = true
			getHisList()
			setTimeout(()=>{
				isGetHisList = false
			},1000)
		}
	},[leftIndex])
    const handleScrollContainer = ()=>{
        chatEndRef.current?.scrollIntoView({ behavior: viewType })
    }
    //获取历史记录
    const getHisList = (n) => {
        getHistoryMessages({context_id: chat_meta?.context_id}).then(res => {
            if (res.code === 200) {
				setViewType('instant')
                setPageList(res.data)
            }
        })
    }
    const chatEndRef = useRef(null);
    const processListFormat = (v)=>{
        let str = "";
        v.map(res=>{
            if(res.includes('-')){
                str += "<span>"+res.replace('-','')+"</span>"
            }else if(res.includes('+')){
                str += "<font>"+res.replace('+','')+"</font>"
            }else{
                str += res
            }
        })
        return str
    }
    return(
        <div className='bg' >
            <div className={`bgWrap ${themeVlue==='default'?'':'drak'}`} id={'scrollable-element'}>
                {
                    pageList && pageList.length > 0 ?
                        pageList.map((res,i) => {
                            return (
                                <div key={'chat-cj'+i}>
                                    {res?.user_content?
                                        <div className="question">
                                            <Row>
                                                <Col span={1}> </Col>
                                                <Col span={19} className="questionInfo" style={sizeStyle}>
                                                    <Question question={res.user_content}/>
                                                </Col>
                                                <Col className='headPortrait' span={4}>
                                                    <Image preview={false} src={userInfo?.avatar} width={30}/>
                                                </Col>
                                            </Row>
                                        </div>:''}
                                    {
                                        res?.responder_content?
                                            <div className="answer">
                                                <Row>
                                                    <Col span={4} className="answerHeadPortrait">
                                                        <Image preview={false}
														   src={chat_meta.responder_avatar?chat_meta.responder_avatar:require('../../../assets/comm/ai-chat-t-head.png')}
														   width={35} height={35} style={{borderRadius:'50%'}}/>
                                                    </Col>
                                                    <Col span={19}>
                                                        {
                                                            res?.responder_content[0]?.state===true?
                                                                <Answer2 setSendTxt={setSendTxt} sendTxt={sendTxt} />:
                                                                <Answer setSendTxt={setSendTxt} sendTxt={sendTxt} answer={res.responder_content} />
                                                        }
                                                        <div style={{marginTop:'10px',color:'#c1c1c1'}}>model: {chat_meta.responder}</div>
                                                    </Col>
                                                    <Col span={1}> </Col>
                                                </Row>
                                            </div>:''
                                    }
                                </div>
                            )
                        })
                        : ''
                }
                <div ref={chatEndRef} />
            </div>

        </div>
    )
};
export default ChatApp;
